import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { mobile } from '../../media-queries'
import { Image } from '../image'
import hero from './hero.svg'

export const HomePageIllustration: React.FC = () => {
  const [t] = useTranslation('aria')

  return (
    <Wrapper>
      <StyledImage src={hero} alt={t('alt-home-illustration')} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
`

const StyledImage = styled(Image)`
  max-width: 100%;
  @media ${mobile} {
    max-width: 226px;
  }
`
